import {
  InMemoryCache,
  InMemoryCacheConfig,
  NormalizedCacheObject,
} from '@apollo/client';
import {
  SynchronousCachePersistor,
  LocalStorageWrapper,
} from 'apollo3-cache-persist';

let cache: InMemoryCache;
let persistor: SynchronousCachePersistor<NormalizedCacheObject>;

const createCache = (options?: InMemoryCacheConfig) => {
  // Create cache
  cache = new InMemoryCache(options);

  // Persist the query
  // Note: when converting this service to a callable function,
  //   replace SynchronousCachePersistor with await persistCache()
  if (process.env.NODE_ENV === 'production') {
    persistor = new SynchronousCachePersistor({
      // @note: There seems to be a conflict with @apollo/client and apollo3-cache-persist versions
      //        as this typing error does not happen on other projects
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      cache: cache as any,
      storage: new LocalStorageWrapper(window.localStorage),
    });
    persistor.restoreSync();
  }

  return cache;
};

/**
 * Returns the singleton cache
 * @returns
 */
export const getCache = (options?: InMemoryCacheConfig): InMemoryCache => {
  if (!cache) {
    return createCache(options);
  }
  return cache;
};

/**
 * Resets the apollo-client cache
 */
export const resetCache = async (): Promise<void> => {
  await cache.reset();
  if (persistor) {
    await persistor.purge();
  }
};
